module.exports = __webpack_public_path__ + "media/KZ-AKM.ca6d4cd3.ogg";